import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "10px 0",
};

export const locationIcon = {
  style: {
    marginRight: spacing.sm,
    width: 20,
    marginTop: 2,
    alignSelf: "flex-start",
  } as CSSProperties,
  htmlColor: greys.slate,
};
